import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {Box, Divider, IconButton, Tooltip} from '@mui/material';
import {useState} from 'react';

import {ExportField} from '../../../interfaces/Export';
import ExportPdfButton from '../../common/ExportPdfButton';
import ModalFixed from '../../common/ModalFixed';
import {BeltHistoryReportDataTab} from './BeltHistoryReport';
import BeltHistoryReportExportExcel from './BeltHistoryReportExportExcel';

interface Props {
  value?: BeltHistoryReportDataTab | null;
  commtrac_external_id?: number;
  params?: {
    date_start?: string;
    date_end?: string;
    page?: number;
    limit?: number;
    order?: string;
    dir?: 'ASC' | 'DESC';
    status?: string;
  };
  exportFields?: ExportField[];
}

const BeltHistoryReportExportButton = ({
  value,
  commtrac_external_id,
  params,
  exportFields,
}: Props) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Export">
        <FileDownloadIcon onClick={() => setIsOpened(true)} />
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <FileDownloadIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Export Belt History</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              <BeltHistoryReportExportExcel
                value={value}
                commtrac_external_id={commtrac_external_id}
              />
              <ExportPdfButton
                endpoint={`/belt/${commtrac_external_id}/history`}
                defaultFilename="belt_history.pdf"
                params={params as Record<string, unknown> | undefined}
                exportFields={exportFields}
              />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}
    </>
  );
};

export default BeltHistoryReportExportButton;
